import React, { useEffect, useState } from 'react'
import { GetPlan } from '../../configurations/crud/reportCrud'

export default function Pricing() {
    const [plan, setPlan] = useState()
    useEffect(() => {
        getPlan()
    }, [])

    const getPlan = async () => {
        try {
            let res = await GetPlan()
            if (res?.data?.result?.succeeded) setPlan(res.data.data)
            else setPlan()
        } catch (err) {
            setPlan()
        }
    }
    return (
        <div class="flex items-center justify-center">
            <div class="max-w-5xl w-full flex flex-col items-center justify-center">
                <div className="mt-2 justify-center">
                    <a href="https://play.google.com/store/apps/details?id=live.doctora.app&pcampaignid=web_share" target='_blank' className='flex items-center'>
                        <img
                            alt="PlayStore"
                            src="/assets/images/play-store.png"
                            className="mx-auto h-9 w-auto"
                        />
                    </a>

                </div>
                <header class="text-center mb-8">
                    <h1 class="text-3xl font-bold text-gray-900">Simple pricing that grows with you</h1>
                </header>
                <div className='w-full md:w-10/12 lg:w-2/3'>
                    <div class="grid grid-cols-1  gap-6">
                        <div class="relative p-1 rounded-3xl">
                            <div class="absolute inset-0 rounded-3xl  opacity-30"></div>
                            <div class="relative bg-white border-brand-400 border-t-4 rounded-3xl p-6 shadow-md transform hover:-translate-y-1 transition-transform">
                                <div class="flex items-center justify-between">
                                    <div>
                                        <h3 class="text-lg font-semibold text-gray-900">OPD Recharge</h3>
                                        <p class="mt-1 text-sm text-gray-500">OPD recharge means you can top up and use as many OPD visits as you need, based on your requirement.</p>
                                    </div>
                                </div>

                                {plan ? <div class="mt-6 flex items-end space-x-3">
                                    <div>
                                        <div class="text-4xl font-extrabold text-gray-900 leading-none">₹{plan.perOPDRate}.00 <span className='text-sm font-normal text-gray-500'>/per opd</span></div>
                                        <div class="text-sm text-gray-500">per use | inclusive {plan.GstSlab} gst</div>
                                    </div>
                                </div>
                                    :
                                    <div className='p-4 w-full flex justify-center'>
                                        <svg aria-hidden="true" role="status" class="inline w-8 h-8 me-3 text-gray-200 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2" />
                                        </svg>
                                        <h1 className='text-lg'>Loading...</h1>
                                    </div>
                                }

                                <ul class="mt-6 space-y-3 text-sm text-gray-600">
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Unlimited opd centers</li>
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Smart notes</li>
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Advanced reporting</li>
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Priority support</li>
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Unlimited Validity</li>
                                </ul>

                                <p class="mt-6 text-xs text-gray-400">You can recharge it after login.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
